// Single source of truth for hostnames, API URLs, and Cognito identifiers
// used by both dashboard apps. Values here are public identifiers, not secrets.
//
// Imported by both browser code and Vite config (Node), so this module must
// stay free of unguarded browser APIs at top level.
export var HUB_URL = 'https://hub.verne.cc';
export var ADMIN_DOMAIN = 'vernerobotics.com';
export var SUPPORT_EMAIL = 'support@vernerobotics.com';
export var ADMIN_PROD_HOST = 'dashboard.verne.engineer';
export var FLEET_VIEWER_URL = 'https://app.vernerobotics.com/fleet';
export var INTERNAL_TOOLS_URL = 'https://verne.engineer';
/** The task explorer owns task creation. Reaching it needs a Cognito session, so
 * only the admin dashboard offers the link. */
export var TASK_EXPLORER_URL = "".concat(INTERNAL_TOOLS_URL, "/#/task-explorer");
/** A task's page in the task explorer. */
export function taskExplorerUrl(taskName) {
    return "".concat(TASK_EXPLORER_URL, "/task/").concat(encodeURIComponent(taskName));
}
/** The ops calendar — who runs which rotation, on which day, on which rig. It
 * owns every assignment write; a rig only reads them. Needs a Cognito session,
 * so only the admin dashboard offers the link. */
export function opsDashboardUrl() {
    return "".concat(INTERNAL_TOOLS_URL, "/#/data-collection");
}
// Hosts here (and their subdomains) are treated as cloud — admin/user dashboards
// served on these require Cognito. Anything else is kiosk (robot-local) mode.
export var CLOUD_DOMAINS = ['verne.cc', 'vernerobotics.com', 'verne.engineer'];
export var LOOPBACK_HOSTS = new Set(['localhost', '127.0.0.1', '::1', '[::1]']);
export var COGNITO = {
    region: 'us-east-1',
    userPoolId: 'us-east-1_LdOWhx4iv',
    hostedUiDomain: 'https://auth.vernerobotics.com',
    adminClientId: '1sl9php1m3uijahoabgj67da2b',
    userClientId: '1jcs88b82g2bai35v90afs5k4f',
};
export function cognitoAuthority() {
    return "https://cognito-idp.".concat(COGNITO.region, ".amazonaws.com/").concat(COGNITO.userPoolId);
}
export function oidcStorageKey(clientId) {
    return "oidc.user:".concat(cognitoAuthority(), ":").concat(clientId);
}
export var isKiosk = (function () {
    var _a;
    if (typeof window === 'undefined')
        return false;
    var host = window.location.hostname;
    if (CLOUD_DOMAINS.some(function (d) { return host === d || host.endsWith('.' + d); }))
        return false;
    if (LOOPBACK_HOSTS.has(host) && ((_a = import.meta.env) === null || _a === void 0 ? void 0 : _a.DEV))
        return false;
    return true;
})();
/** True only when the dashboard is served from a public cloud host. */
export var isCloud = (function () {
    if (typeof window === 'undefined')
        return false;
    var host = window.location.hostname;
    return CLOUD_DOMAINS.some(function (d) { return host === d || host.endsWith('.' + d); });
})();
